(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-footer"] && !Shopify.designMode) return;
  try {
    
  function setupGardenFooter(container) {
    const query = window.matchMedia('(max-width:767px)');
    const groups = container.querySelectorAll('.gp-footer__group');
    const update = () => groups.forEach(group => {
      group.open = !query.matches;
      group.querySelector('summary').tabIndex = query.matches ? 0 : -1;
    });
    update();
    query.addEventListener('change', update);
  }
  document.querySelectorAll('.gp-footer').forEach(setupGardenFooter);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.gp-footer').forEach(setupGardenFooter);
  });

  } catch(e) { console.error(e); }
})();
})();
